// Copyright (c) 2016 Deere & Company

import BusyCounter, {getDefaultState as getBusyCounterDefaultState} from '../../../../shared/state/busy-counter';
import Claim, {getDefaultState as getClaimDefaultState} from '@deere/cps-it.warranty-model-factory/lib/claim-mass-channel-customer-followup';
import ClaimQuestions, {getDefaultState as getClaimQuestionsDefaultState} from './claim-questions';
import ConfirmationModal, {getDefaultState as getConfirmationModalDefaultState} from '../../../shared/state/confirmation-modal';
import CreateClaimModalType, {getDefaultState as getCreateClaimModalTypeDefaultState} from '../../../../shared/state/create-claim-modal';
import Customer, {getDefaultState as getCustomerDefaultState} from '@deere/cps-it.warranty-model-factory/lib/customer';
import FormValidation, {getDefaultState as getDefaultFormValidationState} from './form-validation';
import KeyValuePairCollection, {getDefaultState as getDefaultKeyValueCollection} from '@deere/cps-it.warranty-model-factory/lib/key-value-pair-collection';
import Product, {getDefaultState as getProductDefaultState} from '@deere/cps-it.warranty-model-factory/lib/product';
import WarrantyStatusModal, {getDefaultState as getWarrantyStatusModal} from '../../../shared/state/warranty-status-modal';
import t from 'tcomb';

const MCCFClaim = t.struct({
    busyCounter: BusyCounter,
    claim: Claim,
    confirmationModal: ConfirmationModal,
    createClaimModal: CreateClaimModalType,
    customer: Customer,
    formValidation: FormValidation,
    goodsInstallationVatOptions: KeyValuePairCollection,
    isActionButtonDisabled: t.Boolean,
    isCopied: t.Boolean,
    isEditable: t.Boolean,
    isStickyHeaderVisible: t.Boolean,
    mccQuestions: KeyValuePairCollection,
    methodOfContactOptions: KeyValuePairCollection,
    product: Product,
    questionsRequiredOptions: ClaimQuestions,
    relationshipOptions: KeyValuePairCollection,
    temporaryObjectKey: t.String,
    warrantyStatusModal: WarrantyStatusModal
}, 'NormalClaim');

export const getDefaultState = () =>
    new MCCFClaim({
        busyCounter: getBusyCounterDefaultState(),
        claim: getClaimDefaultState(),
        confirmationModal: getConfirmationModalDefaultState(),
        createClaimModal: getCreateClaimModalTypeDefaultState(),
        customer: getCustomerDefaultState(),
        formValidation: getDefaultFormValidationState(),
        goodsInstallationVatOptions: getDefaultKeyValueCollection(),
        isActionButtonDisabled: false,
        isCopied: false,
        isEditable: true,
        isStickyHeaderVisible: false,
        mccQuestions: getDefaultKeyValueCollection(),
        methodOfContactOptions: getDefaultKeyValueCollection(),
        product: getProductDefaultState(),
        questionsRequiredOptions: getClaimQuestionsDefaultState(),
        relationshipOptions: getDefaultKeyValueCollection(),
        temporaryObjectKey: '',
        warrantyStatusModal: getWarrantyStatusModal()
    });

export default MCCFClaim;



// WEBPACK FOOTER //
// ./src/claim/marketing/mass-channel-customer-followup/state/index.js